import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IpoDetailResolver } from '../core/resolver/ipo-detail-resolver';
import { HomeComponent } from './home/home.component';
import { IpoHomeResolver } from '../core/resolver/ipo-home-resolver';
import { IpoCalendarComponent } from './ipo-calendar.component';
import { DetailComponent } from './detail/detail.component';
import { YearComponent } from './year/year.component';
import { IpoYearResolver } from '../core/resolver/ipo-year-resolver';
import { ExpectedComponent } from './expected/expected.component';
import { NearComponent } from './near/near.component';
import { IpoExpectedResolver } from '../core/resolver/ipo-expected-resolver';
import { IpoNearResolver } from '../core/resolver/ipo-near-resolver';
const routes: Routes = [
  { path: '', component: IpoCalendarComponent,
  children: [
    { path: 'expected',data: { revalidate: 30 },resolve: { ipoExpectedResolver: IpoExpectedResolver  }, component: ExpectedComponent},
    { path: 'near',data: { revalidate: 30 },resolve: { ipoNearResolver: IpoNearResolver  }, component: NearComponent},
    { path: 'year/:year/:month',data: { revalidate: 30 },resolve: { ipoYearResolver: IpoYearResolver  }, component: YearComponent},
    { path: 'year/:year',data: { revalidate: 30 },resolve: { ipoYearResolver: IpoYearResolver  }, component: YearComponent},
    { path: ':url',data: { revalidate: 30 },resolve: { ipoDetailResolver: IpoDetailResolver  }, component: DetailComponent},
    { path: '',resolve: { ipoHomeResolver: IpoHomeResolver}, component: HomeComponent}
  ]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class IpoCalendarRoutingModule { }



